
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/manual/input_score",
      function () {
        return require("private-next-pages/manual/input_score.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/manual/input_score"])
      });
    }
  